import { render, staticRenderFns } from "./imagesearch.vue?vue&type=template&id=45d21998&scoped=true&"
import script from "./imagesearch.vue?vue&type=script&lang=ts&"
export * from "./imagesearch.vue?vue&type=script&lang=ts&"
import style0 from "./imagesearch.vue?vue&type=style&index=0&id=45d21998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d21998",
  null
  
)

export default component.exports